module.exports = __webpack_public_path__ + "static/assets/d70bdf0d8f0d579e02f23a4a9340a861.svg";